export const APP_TABS = [
  { id: 'dashboard', label: 'Общая статистика', group: 'primary' },
  { id: 'employees', label: 'Сотрудники', group: 'primary' },
  { id: 'calls', label: 'Детали звонков', group: 'primary' },
  { id: 'missed', label: 'Пропущенные', group: 'primary' },
  { id: 'evaluation', label: 'Оценка сотрудников', group: 'primary' },
  { id: 'clients', label: 'Клиенты', group: 'primary' },
  { id: 'complaints', label: 'Жалобы', group: 'primary' },
  { id: 'integrations', label: 'Интеграции', group: 'primary' },
  { id: 'settings', label: 'Настройки', group: 'secondary' },
  { id: 'help', label: 'Помощь и поддержка', group: 'secondary' }
];

export const APP_TAB_IDS = APP_TABS.map(({ id }) => id);
export const PRIMARY_APP_TABS = APP_TABS.filter(({ group }) => group === 'primary');
export const SECONDARY_APP_TABS = APP_TABS.filter(({ group }) => group === 'secondary');
